import { useSidebar } from 'shared/ui/sidebar';
import { useLayoutEffect } from 'react';

export const useSidebarEffect = (state: boolean) => {
  const { setOpen } = useSidebar();
  useLayoutEffect(() => {
    setOpen(state);
  }, []);

  return null;
};
